import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "size", "titleText"];
import PropTypes from 'prop-types';
import classNames from 'classnames';
import I18n from 'I18n';
import { ICON_SIZES } from '../icon/IconConstants';
import UIIcon from '../icon/UIIcon';
import lazyEval from '../utils/lazyEval';
import createLazyPropType from '../utils/propTypes/createLazyPropType';
import { jsx as _jsx } from "react/jsx-runtime";
export default function UILockBadge(_ref) {
  let {
      className,
      size,
      titleText = () => I18n.text('salesUI.UILockBadge.title')
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const classes = classNames('private-lock-badge', className);
  return /*#__PURE__*/_jsx(UIIcon, Object.assign({}, rest, {
    "aria-label": lazyEval(titleText),
    className: classes,
    name: "locked",
    size: size
  }));
}
UILockBadge.propTypes = {
  size: PropTypes.oneOfType([PropTypes.oneOf(Object.keys(ICON_SIZES)), PropTypes.number]),
  titleText: createLazyPropType(PropTypes.string).isRequired
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UILockBadge.defaultProps = {
  titleText: () => I18n.text('salesUI.UILockBadge.title')
};
UILockBadge.displayName = 'UILockBadge';